import $ from 'jquery';
import Cookies from 'js-cookie';

export default function initializeShopifyYCookie() {
  $('.js-shopify-y-cookie').val(Cookies.get('_shopify_y'));
  $("[name='subscriber_param_shopify_y']").val(Cookies.get('_shopify_y'));
}
